function init() {
    
  if ( $('.course-progress .timeline li a').length > 0 ) {
    var timelineItem = $('.course-progress .timeline li a');
    
    timelineItem.each(function() {
      var timelineLabel = $(this).find('.title span');

      $(this).hover(function() {
        var rPosition = ($(window).width() - ( timelineLabel.offset().left + timelineLabel.outerWidth() ));
        var lPosition = ($(window).width() - ( timelineLabel.offset().left ));
        // console.log(rPosition + ' ' + lPosition);
    
        // console.log('rPosition: ' + rPosition + ' | lPosition: ' + lPosition );
    
        if ( rPosition < 0 ) {
          timelineLabel.attr('style', 'transform: translateY(0) translateX(' + rPosition + 'px)');
        }
        if ( lPosition < 0 ) {
          timelineLabel.attr('style', 'transform: translateY(0) translateX(' + lPosition + 'px)');
        }
      });
      $(this).mouseleave(function() {
        timelineLabel.attr('style', '');
      });
    });
  }

}

module.exports = { init };